import { FakeApiItemsGateway, } from "./gateway/fakeApiItemsGateway";
import { FakeApiFilesGateway, } from "./gateway/fakeApiFilesGateway";
export * from "./helpers";
export { FakeApiItemsGateway, FakeApiFilesGateway };
//# sourceMappingURL=index.js.map